import type { ChessBoard, ChessPosition } from '../../types/chess';
import type { MoveValidationContext } from './types';
import { generatePawnMoves, generateSlidingMoves, generateKnightMoves, generateKingMoves } from './core';
import { isInCheck } from './validation';

export function getValidMoves({ board, position, skipCheckValidation = false }: MoveValidationContext): ChessPosition[] {
  const piece = board[position.row][position.col];
  if (!piece) return [];

  const moves: ChessPosition[] = [];
  const context = { board, row: position.row, col: position.col, color: piece.color, moves };

  switch (piece.type) {
    case 'pawn':
      generatePawnMoves(context);
      break;
    case 'rook':
      generateSlidingMoves(context, [[0, 1], [0, -1], [1, 0], [-1, 0]]);
      break;
    case 'knight':
      generateKnightMoves(context);
      break;
    case 'bishop':
      generateSlidingMoves(context, [[1, 1], [1, -1], [-1, 1], [-1, -1]]);
      break;
    case 'queen':
      generateSlidingMoves(context, [
        [0, 1], [0, -1], [1, 0], [-1, 0],
        [1, 1], [1, -1], [-1, 1], [-1, -1]
      ]);
      break;
    case 'king':
      generateKingMoves(context);
      break;
  }

  if (skipCheckValidation) {
    return moves;
  }

  return moves.filter(move => {
    const newBoard = board.map(row => [...row]);
    newBoard[move.row][move.col] = newBoard[position.row][position.col];
    newBoard[position.row][position.col] = null;
    return !isInCheck(newBoard, piece.color);
  });
}